module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/static-page/edit-page/edit-page.component.css
// module id = ./src/app/static-page/edit-page/edit-page.component.css
// module chunks = main